'use client';

import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface SectionGridProps {
  children: ReactNode;
  className?: string;
}

/** Responsive 2-column grid for paired sections (goals/challenges, pains/opportunities, etc.) */
export function SectionGrid({ children, className }: SectionGridProps) {
  return (
    <div className={cn('grid grid-cols-1 md:grid-cols-2 gap-6', className)}>
      {children}
    </div>
  );
}
